import type React from 'react';
import classes from './ThreeDotsLoader.module.css';

const ThreeDotsLoader: React.FC = () => {
  return (
    <output className={classes.threeDotsLoader} aria-label="Loading">
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
    </output>
  );
};

export default ThreeDotsLoader;
